export const progressBar = {
  name: 'vch-progress-bar',
  inserted: (el, binding) => {
    const targetValue = binding.value > 0 ? binding.value : 100 + binding.value;
    const barEl = el.querySelector('span');
    barEl.style.width = `${targetValue}%`;
  },
};
